<template>
  <div
    :style="playerStyles"
    class="main"
  >
    <div
      :class="['main-wrap', {hide: showSubscribe && size !== 'size-mini'}, {dark: isDark}, {[size]:size}]"
    >
      <Audio />

      <Logo />

      <PlayerMainArtworkMeta />

      <PlayerMainControls />
    </div>
  </div>
</template>

<script>
import Audio from './Audio'
import Logo from './Logo'
import PlayerMainArtworkMeta from './PlayerMainArtworkMeta'
import PlayerMainControls from './PlayerMainControls'
import Store from '../store'

export default {
  components: {
    Audio,
    Logo,
    PlayerMainArtworkMeta,
    PlayerMainControls
  },
  data () {
    return { store: Store }
  },
  computed: {
    isDark () { return this.store.state.isDark },
    playerStyles () {
      return {
        background: this.store.state.color
      }
    },
    showSubscribe () { return this.store.state.showSubscribe },
    size () { return this.store.state.size }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import '../assets/styles/breakpoints.scss';

.main {
  height: 100%;
}
.main-wrap {
  border-radius: 2px;
  border: solid 2px $black-trans-100;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  opacity: 1;
  padding: 8px 8px 6px 8px;
  position: relative;
  transition: opacity .5s;

  &.hide {
    opacity: 0;
  }

  @media (min-width: $bp_xs) {
    padding: 0 14px;
  }
  @media (min-width: $bp_sm) {
    flex-direction: row;
     padding: 0 16px;
  }

  &:after {
    background-color: $black-trans-100;
    bottom: 0;
    content: "";
    display: block;
    height: 60px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 0;

    @media (min-width: $bp_xs) {
      height: 80px;
    }
    @media (min-width: $bp_sm) {
      height: 98px;
    }
  }
  &.dark {
    border: solid 2px $white-trans-300;

    &:after {
      background-color: $white-trans-200;
    }
  }
  .logo {
    box-sizing: content-box;
    padding: 8px;
    height: 20px;
    right: 0;
    top: 0;
    width: 20px;
    z-index: 100;

    @media (min-width: $bp_xs) {
      padding: 14px;
    }
    @media (min-width: $bp_sm) {
      padding: 16px;
    }
  }
  // MINI PLAYER STYLES
  &.size-mini {
    padding: 6px;

    &:after {
      display: none;
    }
  }
}
</style>
